import Vue from "vue";

import "@/plugins/config.js";
import "@/services";
import { ENDPOINTS } from "@/services/Endpoints.js";

Vue.prototype.$packageEmitReport = new Vue({
  data() {
    return {
      ENDPOINTS,
      loader: false,
      loaderExportCSV: false,
      loaderExportPDF: false,
      emittedPackages: [],
      totalsEmittedPackages: [],
      filter: {
        store: null,
        consumer: null,
        dateInterval: null,
        rangeDates: [],
        error: {
          rangeDates: [],
        },
      },
      dateRanges: [
        { text: "Dia", value: "date" },
        { text: "Semana", value: "week" },
        { text: "Mês", value: "month" },
        { text: "Personalizado", value: "custom" },
      ],
    };
  },
  methods: {
    handleFilter() {
      const {
        store: loja,
        consumer: idconsumidor,
        rangeDates: dateHour,
      } = this.filter;

      const { post } = this.$axios;

      post(this.ENDPOINTS.PACKAGE_EMIT_REPORT, {
        loja,
        idconsumidor,
        dthr_ini: dateHour.length > 0 ? dateHour[0] + " 00:00" : null,
        dthr_fim: dateHour.length > 0 ? dateHour[1] + " 23:59" : null,
      }).then(response => {
        const data = Object.entries(response.info).map(e => e[1]);
        this.emittedPackages = data;
        this.totalsEmittedPackages = [response.totais];
      });
    },
    handleExportCSV() {
      this.loaderExportCSV = true;
      const {
        store: loja,
        consumer: idconsumidor,
        rangeDates: dateHour,
      } = this.filter;

      const { postPDF } = this.$axios;

      postPDF(this.ENDPOINTS.PACKAGE_EMIT_REPORT, {
        loja,
        idconsumidor,
        dthr_ini: dateHour.length > 0 ? dateHour[0] + " 00:00" : null,
        dthr_fim: dateHour.length > 0 ? dateHour[1] + " 23:59" : null,
        exportation: "CSV",
      }).then(response => {
        if (response) {
          var a = document.createElement("a");
          document.body.appendChild(a);
          a.style = "display: none";
          var file = new Blob([response], { type: "text/csv" });
          var fileURL = URL.createObjectURL(file);
          a.href = fileURL;
          a.download = "Relatório de Emissão de Pacotes";
          a.click();
          window.URL.revokeObjectURL(fileURL);
          this.loaderExportCSV = false;
        }
      });
    },
    handleExportPDF() {
      this.loaderExportPDF = true;
      const {
        store: loja,
        consumer: idconsumidor,
        rangeDates: dateHour,
      } = this.filter;

      const { postPDF } = this.$axios;

      postPDF(this.ENDPOINTS.PACKAGE_EMIT_REPORT, {
        loja,
        idconsumidor,
        dthr_ini: dateHour.length > 0 ? dateHour[0] + " 00:00" : null,
        dthr_fim: dateHour.length > 0 ? dateHour[1] + " 23:59" : null,
        exportation: "PDF",
      }).then(response => {
        if (response) {
          var file = new Blob([response], { type: "application/pdf" });
          var fileURL = URL.createObjectURL(file);
          window.open(fileURL);
          this.loaderExportPDF = false;
        }
      });
    },
    clearFilterFields() {
      this.filter.store = null;
      this.filter.consumer = null;
      this.filter.dateInterval = null;
      this.filter.rangeDates = [];
      this.filter.error.rangeDates = [];
    },
  },
});
